export default "/images/trash-1.svg?a864b6b6ee9ef0386c78eef0d2982559";